const COLORS = {
  gold: "#B19648",
  lightGold: "#DDB677",
  darkGrey: "#212121",
  lightGrey: "#767676",
  disabledGrey: "#C2C1C1",
  contentGrey: "#F2F3F5",
  white: "#FFFFFF",
  transparent: "#00000000",
  whiteTransparent: "rgba(255, 255, 255, 0.9)",
  blackTransparent: "rgba(0, 0, 0, 0.2)",
  borderLightGrey: "rgba(34, 36, 38, 0.1)",
  borderDarkGrey: "#d4d4d5",
  backgroundLightGrey: "#F9FAFB",
  red: "#db2828",
  blue: "#2185D0",
  darkBlue: "#1B5BA4",
  yellow: "#FBBD08",
  lightYellow: "rgba(251, 189, 8, 0.4)",
  // ----- dark theme ------- //
  // navyBlue: "rgb(26, 53, 91)",
  // navyBlueDark: "rgba(21, 42, 73,1)",
  // textOnNavyBlue: "rgba(201,218,241,1)",
  // textOnNavyBlueHightLight: "#F4B41A",
  // ----- light theme ------- //
  navyBlue: "#043776",
  navyBlueOnLighBG: "#0a4c9a",
  navyBlueDark: "rgba(21, 42, 73,1)",
  textOnNavyBlue: "rgba(201,218,241,1)",
  textOnNavyBlueHightLight: "#FFC704",
  black: "#000000",
  navyBlueDarkIIPM: "rgba(36, 47, 107)",
};
export default COLORS;
